import InlineServiceCard from "./InlineServiceCard";

export default InlineServiceCard;

export { InlineServiceCard };
